import React, { useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
import Image from "../../../UI/Image/Image"
import { addTrailingSlash } from "../../../../helpers/utils"
import useOutsideClick from "../../../../hooks/useOutsideClick"
import * as styles from "./LanguageSelection-tw-styles"

const LanguageSelection = props => {
  const { languages = []} = props
  const style = styles.defaultStyle
  const [isOpen, setIsOpen] = useState(false)
  //const [lang, setLang] = useState(defaultLanguage)

  let lang;
  if(typeof window != 'undefined'){
    lang = window.location.pathname.split('/').filter(Boolean)[0];
    lang = /^[A-Za-z]{1,2}$/.test(lang) ? lang : 'en';
  }

  let menuTitle = languages.find(l => l.code === lang)?.label || "LANGUAGE";


  const options = useMemo(() => {
    return languages.map(op => ({
      ...op,
      url: addTrailingSlash(op.url),
    }))
  }, [languages])

  useEffect(() => {
    const slug = addTrailingSlash(window.location.pathname)
    for (const op of options) {
      if (slug === op.url) {
        setLang(op)
        break
      }
    }
  }, [])

  const handleChange = (e, option) => {
    e.stopPropagation();
    // window.location = option.url
    // setLang(option)
    const langRoot = option.code === 'en' ? '/' : `/${option.code}/`;
    window.location = langRoot;
  }

  const handleToggle = () => {
    setIsOpen(prev => !prev)
  }
  const close = ()=>{
    if(isOpen){
      setIsOpen(false)
    }
  }
 
  const ref = useOutsideClick(isOpen, close)

  return (
    <div className={style.languageWrapperBtn}>
      <button
        className={`${style.wrapper} ${isOpen ? "open" : "close"}`}
        onClick={handleToggle}
        ref={ref}
      >
        <span className={style?.selectedLang}>{menuTitle}</span>
        <ul className={style?.languageList}>
          {options.filter(l => l.code != lang).map(op => (
            <li
              id={op.label}
              key={op.label}
              className={`${style.option} ${lang && op.url === lang.url ? "selected" : " "}`}
              onClick={e => handleChange(e, op)}
            >
              {op.image && <Image contentfulImage={op.image} />}
              <span>{op.label}</span>
            </li>
          ))}
        </ul>
      </button>
    </div>
  )
}

LanguageSelection.propTypes = {
  languages: PropTypes.array,
  defaultLanguage: PropTypes.object
}

export default React.memo(LanguageSelection)
